import { CheckIcon } from "@/Icons/v2/Check";

import { twMerge } from "tailwind-merge";

type Props = {
  checked: boolean;
  indeterminate?: boolean;
  onToggle?: () => void;
};

export const ReportingTableCheckbox: React.FC<Props> = ({
  checked,
  indeterminate = false,
  onToggle,
}) => (
  <button
    onClick={(e) => {
      e.stopPropagation();
      onToggle?.();
    }}
    className={twMerge(
      "flex h-[17px] w-[17px] flex-none cursor-pointer items-center justify-center rounded-[4px] border border-solid p-0",
      checked || indeterminate
        ? "border-[#1D1C1C] bg-[#1D1C1C]"
        : "border-grey4 bg-white",
    )}
  >
    {checked && <CheckIcon />}
    {indeterminate && !checked && (
      <span className="h-[2px] w-[9px] rounded-[1px] bg-white" />
    )}
  </button>
);
